export default defineAppConfig({
    navigation: {
        accountSwitchReRoute: {
            "apps-id": "apps-id",
            "apps-id-connectionId": "apps-id",
            "apps-id-connectionId-events": "apps-id",
            "apps-id-connectionId-runs": "apps-id",
            "apps-id-connectionId-tasks": "apps-id",
            "apps-id-edit": "apps-id",
            "apps-afas_old": "apps",
            "apps-salesforce-id-edit": "apps",
            "apps-whatsapp-connection-channels-channel": "apps",
            "automations-id": "automations",
            "automations-id-edit": "automations",
            "automations-id-events": "automations",
            "automations-id-runs": "automations",
            "automations-id-tasks": "automations",
            "automations-id-workflow": "automations",
            "emails-id": "emails",
            "forms-id": "forms",
            "inbox-roomId": "inbox",
            "inbox-email-roomId": "inbox-email",
            "inbox-responses-id": "inbox-responses",
            "inbox-whatsapp-roomId": "inbox-whatsapp",
            "messages-id": "messages",
            "messages-new": "messages",
            "people-id": "people",
            "settings-account-brands-id": "settings-account-brands",
            "settings-account-domains-id": "settings-account-domains",
            "settings-account-locations-id": "settings-account-locations",
            "settings-account-users-id": "settings-account-users",
            "events-id": "events",
            "runs-id": "runs",
            "tasks-id": "tasks",
        },
    },
    ui: {
        primary: "hd-secondary",
        cool: "hd-neutral",
        button: {
            base: "transition duration-150 ease-in-out transform active:scale-95 disabled:active:scale-100 focus:outline-none focus-visible:outline-0 disabled:cursor-not-allowed disabled:opacity-75 flex-shrink-0",
            variant: {
                none: "",
            },
            color: {
                "hd-primary": {
                    solid: "shadow-sm text-white dark:text-hd-primary-900 bg-hd-primary-900 hover:bg-hd-primary-800 disabled:bg-hd-primary-900 dark:bg-white dark:hover:bg-hd-primary-100 dark:disabled:bg-white focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400",
                    link: "text-hd-primary-900 dark:text-white underline-offset-4 hover:underline focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400",
                },
                "hd-secondary": {
                    soft: "text-hd-secondary-original dark:text-hd-secondary-400 bg-hd-secondary-100 hover:bg-hd-secondary-200 disabled:bg-hd-secondary-100 dark:bg-hd-secondary-950 dark:hover:bg-hd-secondary-900 dark:disabled:bg-hd-secondary-950 focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-hd-secondary-original dark:focus-visible:ring-hd-secondary-400",
                },
            },
        },
        input: {
            color: {
                form: {
                    solid: "shadow-sm text-[color:--form-input-color] bg-[color:--form-input-background-color] focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-[color:--form-button-color]",
                    soft: "text-[color:--form-input-color]  bg-[--form-input-background-color-soft] focus:bg-[--form-input-background-color] ring-[color:--form-input-background-color] ring-2 focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[color:--form-button-color]",
                    outline:
                        "shadow-sm bg-transparent text-[color:--form-input-color] ring-1 ring-inset ring-[color:--form-input-background-color] focus:ring-2 focus:ring-[color:--form-button-color]",
                },
            },
        },
        notifications: {
            position:
                "top-0 left-1/2 right-auto bottom-auto transform -translate-x-1/2 justify-start",
        },
        popover: {
            base: "focus:outline-none",
        },
        tooltip: {
            container: "z-[999] group",
        },
        selectMenu: {
            default: {
                showCreateOptionWhen: "always",
            },
        },
    },
});
